import { InjectionToken, WritableSignal } from '@angular/core';
import { KeyValueCache } from './utils/create-cache';

export interface SelfCheckoutParams {
  hasTerminal?: boolean;
  /** Replaces the terminal payment with a simulated one; nothing is booked on the backend. */
  demoPayment?: boolean;
  /** Company the workstation is bound to; only used when the JWT carries no `firmaid`. */
  companyId?: number;
}

export const SOFTLINE_CONFIG_WWS_SELF_CHECKOUT_PARAMS = new InjectionToken<SelfCheckoutParams>(
  'SOFTLINE_CONFIG_WWS_SELF_CHECKOUT_PARAMS'
);

export const SOFTLINE_WWS_SELF_CHECKOUT_IMG_CACHE = new InjectionToken<
  KeyValueCache<string>
>('SOFTLINE_WWS_SELF_CHECKOUT_IMG_CACHE');

export const SOFTLINE_WWS_SELF_CHECKOUT_CATEGORIES_IMG_CACHE = new InjectionToken<
  KeyValueCache<string>
>('SOFTLINE_WWS_SELF_CHECKOUT_CATEGORIES_IMG_CACHE');

export const SOFTLINE_WWS_SELF_CHECKOUT_ROUTE_PATH = new InjectionToken<{ routePath: string }>(
  'SOFTLINE_WWS_SELF_CHECKOUT_ROUTE_PATH'
);

export const SOFTLINE_WWS_SELF_CHECKOUT_IS_CASHIER = new InjectionToken<
  WritableSignal<boolean>
>('SOFTLINE_WWS_SELF_CHECKOUT_IS_CASHIER');

export const SOFTLINE_PERMISSION_SCO = 'SOFTAPP.SCO';
